<template>
  <div id="wrapper"><router-view /></div>
</template>

<script>
export default {}
</script>